import React from "react";
import { Provider } from "react-redux";
import { Router, Route } from "react-router";
import SurveyContainer from "./containers/SurveyContainer";

export default function App(store, history) {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Route
          path="/employers/:employerURLKey/locations/:locationURLKey"
          component={SurveyContainer}
        />
      </Router>
    </Provider>
  );
}



// WEBPACK FOOTER //
// ./src/app.js